<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <el-form :model="formInline"
                   class="demo-form-inline">
            <el-col :span="8">
              <el-form-item label="类型：">
                <el-select v-model="formInline.type"
                           clearable
                           placeholder="全部">
                  <el-option label="正常日志"
                             :value="0"></el-option>
                  <el-option label="异常日志"
                             :value="9"></el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间：">
                <!--<el-input v-model="formInline.createTime"
                          placeholder=""></el-input>-->
                <el-date-picker
                  v-model="formInline.createTime"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="截止日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-button type="primary"
                           style="margin-left:20px"
                           @click="current=1;onSubmit()">查询</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                   style="margin-right:10px"></i>日志列表</p>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <div style="overflow:auto">
                <el-table border
                          ref="multipleTable"
                          :data="tableData"
                          tooltip-effect="dark"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection">
                  </el-table-column>
                  <el-table-column label="类型"
                                   width="100">
                    <template slot-scope="scope">
                      <span v-show="scope.row.type==0">正常日志</span>
                      <span v-show="scope.row.type==9">错误日志</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="title"
                                   label="标题">
                  </el-table-column>
                  <el-table-column prop="remoteAddr"
                                   label="IP地址">
                  </el-table-column>
                  <el-table-column prop="method"
                                   label="请求方式">
                  </el-table-column>
                  <el-table-column prop="time"
                                   label="请求时间">
                  </el-table-column>
                  <el-table-column prop="createBy"
                                   label="创建人">
                  </el-table-column>
                  <el-table-column prop="createTime"
                                   label="创建时间">
                    <template slot-scope="scope">{{  scope.row.createTime.replace("T", " ")}}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-top: 20px;padding:20px">
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {  getmenusubmenu, getLogPage } from '../../API'
export default {
  data () {
    return {
      pickerOptions: {
          disabledDate(time) {
              //return time.getTime() < Date.now() - 8.64e7;//设置选择今天以及今天之后的日
              return time.getTime() > Date.now(); //设置选择今天以及今天以前的日期
          },
      },
      formInline: {},
      checked: false,
      total: 0,
      current: 1,
      tableData: [],
      value: '1',
      multipleSelection: [],
      menuList: []
    }
  },
  created () {
    getLogPage().then(res => {
      if (res.code === 0) {
        this.total = res.data.total;
        this.current = res.data.current;
        this.tableData = res.data.records
      }
    })
    getmenusubmenu(localStorage.getItem('parentId')).then(res => {
      if (res.code === 0) {
        this.menuList = res.data
      }
    })
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    onSubmit () {
        let resultArr = this.formInline.createTime;
        // 判断数组是否为空
        if (resultArr instanceof Array) {
            if (typeof resultArr != "undefined" && resultArr != null && resultArr.length > 0) {
                console.log("ceshi")
                this.formInline.createTime = this.formInline.createTime.join();
            }
        }
        let params = this.formInline
        params.current = this.current
        getLogPage(params).then(res => {
            if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
            }
        })
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
/deep/.el-input {
  width: 217px;
}
/deep/ .el-table {
  max-width: 200%;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
  /deep/ .el-input {
    width: 50px;
  }
}
</style>
